import { AppAction } from './enum';
import { Overlay } from '@vfde-brix/ws10/overlay';
import { OverlayView } from '../../enum';
import { JarvisProduct } from '@vfde-sails/availability';
import { Selected } from '../../interface';

export const initApp = (overlay: Overlay | null) => ({
    type: AppAction.INIT_APP as const,
    overlay,
});

export const setLoading = (isLoading = true) => ({
    type: AppAction.SET_LOADING as const,
    isLoading,
});

export const setOverlayVisibility = (value: OverlayView | boolean) => ({
    type: AppAction.SET_OVERLAY_VISIBILITY as const,
    value,
});

export const setOverlayLoaded = (isLoaded: boolean) => ({
    type: AppAction.SET_OVERLAY_LOADED as const,
    isLoaded,
});

export const setError = (error?: unknown) => ({
    type: AppAction.SET_ERROR as const,
    error,
});

export const setSelectedGigakombi = (gigakombi: string, shouldTrack = true) => ({
    type: AppAction.SET_SELECTED_GIGAKOMBI as const,
    gigakombi,
    shouldTrack,
});

export const setProductDetails = (products?: Record<string, JarvisProduct>) => ({
    type: AppAction.SET_PRODUCT_DETAILS as const,
    products,
});

export const setSelectedProduct = (productEntry: Partial<Selected>, shouldTrack = true) => ({
    type: AppAction.SET_SELECTED_PRODUCT as const,
    productEntry,
    shouldTrack,
});

export type Actions = ReturnType<typeof initApp>
    | ReturnType<typeof setLoading>
    | ReturnType<typeof setOverlayVisibility>
    | ReturnType<typeof setError>
    | ReturnType<typeof setOverlayLoaded>
    | ReturnType<typeof setSelectedGigakombi>
    | ReturnType<typeof setProductDetails>
    | ReturnType<typeof setSelectedProduct>;
